<template>
	<div class="pageContainer">
		<PageHeader
			addClass="is-robot"
			:image="require('../assets/robot/title_pc.svg')"
			:imageSp="require('../assets/robot/title_sp.svg')"
			alt="労働可能人口の減少や労働環境の改善に、産業用ロボットの開発や工場へのロボット導入で貢献する。"
			intro="ロボット領域では、ロボットメーカー向けの新規ロボットの開発支援や、<br class='over_display'>ロボット導入を検討しているユーザー向けのロボットシステムインテグレート（ロボットSI)および<br class='over_display'>コンサルティングを実施しています。その強みやプロジェクト事例について紹介します。"
		/>
		<BgTitleBox
			:bgPc="require('../assets/robot/bgBox_pc.jpg')"
			:bgSp="require('../assets/robot/bgBox_sp.jpg')"
			title="ロボット領域の概要"
		/>
		<RobotArticle />
	</div>
</template>

<script>
import PageHeader from '@/components/mainpage/PageHeader.vue';
import BgTitleBox from '@/components/common/BgTitleBox.vue';
import RobotArticle from '../components/mainpage/RobotArticle.vue';
export default {
	name: 'robot',
	components: {
		PageHeader,
		BgTitleBox,
		RobotArticle,
	},
};
</script>

<style lang="scss" scoped>
.pageContainer {
	position: relative;
	overflow: hidden;
	width: 100%;
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 100px;
	}
	&::after {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		bottom: 0;
		left: 0;
		transform: skewY(-18deg);
		transform-origin: left top;
		z-index: -1;
		@media print, screen and (min-width: 1161px) {
			bottom: 0px;
		}
	}
}
</style>
